document.addEventListener('DOMContentLoaded', function() {
  initVariantCards();
  initAccordions();
  
  // Re-initialize when sections are reloaded by Shopify
  document.addEventListener('shopify:section:load', function(event) {
    initVariantCards();
    initAccordions();
  });
  
  // Re-initialize accordions on window resize
  window.addEventListener('resize', function() {
    initAccordions();
  });

  // Listen for variant changes to update availability
  if (typeof jQuery !== 'undefined') {
    jQuery(window).on('cc-variant-updated', function() {
      document.querySelectorAll('.variant-cards-container').forEach(function(container) {
        updateVariantCardAvailability(container);
      });
    });
  }
});

/**
 * Get product data from the page JSON
 */
function getProductDataForContainer(container) {
  const productArea = container.closest('.product-area');
  if (!productArea) return null;

  const productId = productArea.getAttribute('data-product-id');
  if (!productId) return null;

  const jsonScript = document.getElementById('cc-product-json-' + productId);
  if (!jsonScript) return null;

  try {
    return JSON.parse(jsonScript.textContent);
  } catch (e) {
    console.error('Error parsing product JSON:', e);
    return null;
  }
}

/**
 * Get current selections from all option selectors
 */
function getCurrentSelections(productArea) {
  const selections = [];
  const selectorWrappers = productArea.querySelectorAll('.selector-wrapper');

  selectorWrappers.forEach(function(wrapper) {
    const cardContainer = wrapper.querySelector('.variant-cards-container');
    let selectedValue = null;

    if (cardContainer) {
      const cardSelect = cardContainer.querySelector('.variant-cards-select');
      selectedValue = cardSelect ? cardSelect.value : null;
    } else {
      const regularSelect = wrapper.querySelector('select');
      selectedValue = regularSelect ? regularSelect.value : null;
    }

    if (selectedValue !== null) {
      selections.push(selectedValue);
    }
  });

  return selections;
}

/**
 * Build availability map for variant cards
 * Bidirectional algorithm - checks ALL other selected options, not just parents
 */
function buildAvailabilityMap(productData, currentSelections) {
  const availabilityMap = {};
  const numOptions = productData.options ? productData.options.length : 0;

  if (numOptions === 0) return availabilityMap;

  // For each option position, determine which values are available
  for (let optionIndex = 0; optionIndex < numOptions; optionIndex++) {
    availabilityMap[optionIndex] = {};

    // Get all possible values for this option
    productData.variants.forEach(function(variant) {
      const value = variant.options[optionIndex];
      if (value && !(value in availabilityMap[optionIndex])) {
        availabilityMap[optionIndex][value] = false;
      }
    });

    // Find variants that match ALL OTHER selected options (not just parents)
    const matchingVariants = productData.variants.filter(function(variant) {
      for (let j = 0; j < currentSelections.length; j++) {
        // Skip the current option index - we're checking what values are available FOR this option
        if (j === optionIndex) continue;

        // If there's a selection for this other option, variant must match it
        if (currentSelections[j] && variant.options[j] !== currentSelections[j]) {
          return false;
        }
      }
      return true;
    });

    // Check which values of current option have available variants
    matchingVariants.forEach(function(variant) {
      if (variant.available) {
        const value = variant.options[optionIndex];
        if (value) {
          availabilityMap[optionIndex][value] = true;
        }
      }
    });
  }

  return availabilityMap;
}

/**
 * Update variant card availability classes
 */
function updateVariantCardAvailability(container) {
  const productArea = container.closest('.product-area');
  if (!productArea) return;

  const productData = getProductDataForContainer(container);
  if (!productData || !productData.variants) return;

  const currentSelections = getCurrentSelections(productArea);
  const availabilityMap = buildAvailabilityMap(productData, currentSelections);

  // Get the option position for this container
  const selectorWrapper = container.closest('.selector-wrapper');
  if (!selectorWrapper) return;

  // Find which option index this container represents
  const allWrappers = Array.from(productArea.querySelectorAll('.selector-wrapper'));
  const optionIndex = allWrappers.indexOf(selectorWrapper);
  if (optionIndex === -1) return;

  const cards = container.querySelectorAll('.variant-card');
  cards.forEach(function(card) {
    const value = card.getAttribute('data-variant-value');
    const isAvailable = availabilityMap[optionIndex] && availabilityMap[optionIndex][value];
    card.classList.toggle('variant-card--unavailable', !isAvailable);
  });
}

/**
 * Find the closest available variant when clicking an unavailable option
 * Prioritizes keeping earlier options (Option 1 > Option 2 > Option 3)
 */
function findClosestAvailableVariant(productData, clickedOptionIndex, clickedValue, currentSelections) {
  // Find all available variants that have the clicked value at the clicked position
  const availableVariants = productData.variants.filter(function(variant) {
    return variant.available && variant.options[clickedOptionIndex] === clickedValue;
  });

  if (availableVariants.length === 0) {
    return null;
  }

  // If only one option, return the first available variant
  if (availableVariants.length === 1) {
    return availableVariants[0];
  }

  // Score each variant by how well it matches current selections
  // Weight earlier options more heavily
  const numOptions = productData.options ? productData.options.length : currentSelections.length;
  const scoredVariants = availableVariants.map(function(variant) {
    let score = 0;

    for (let i = 0; i < numOptions; i++) {
      if (i === clickedOptionIndex) continue; // Skip the clicked option

      if (variant.options[i] === currentSelections[i]) {
        // Weight earlier options more (Option 1 gets highest weight)
        score += (numOptions - i);
      }
    }

    return { variant: variant, score: score };
  });

  // Sort by score descending and return the best match
  scoredVariants.sort(function(a, b) {
    return b.score - a.score;
  });

  return scoredVariants[0].variant;
}

/**
 * Update all option selectors to match a given variant
 */
function updateAllSelectionsToVariant(variant, productArea) {
  const selectorWrappers = productArea.querySelectorAll('.selector-wrapper');

  selectorWrappers.forEach(function(wrapper, index) {
    const newValue = variant.options[index];
    if (!newValue) return;

    // Update card container if present
    const cardContainer = wrapper.querySelector('.variant-cards-container');
    if (cardContainer) {
      const cardSelect = cardContainer.querySelector('.variant-cards-select');
      if (cardSelect) {
        // Update hidden select
        for (let i = 0; i < cardSelect.options.length; i++) {
          if (cardSelect.options[i].value === newValue) {
            cardSelect.selectedIndex = i;
            break;
          }
        }
      }

      // Update card visual selection
      const cards = cardContainer.querySelectorAll('.variant-card');
      cards.forEach(function(card) {
        const cardValue = card.getAttribute('data-variant-value');
        card.classList.toggle('variant-card--selected', cardValue === newValue);
      });
    } else {
      // Update regular select
      const regularSelect = wrapper.querySelector('select');
      if (regularSelect) {
        for (let i = 0; i < regularSelect.options.length; i++) {
          if (regularSelect.options[i].value === newValue) {
            regularSelect.selectedIndex = i;
            break;
          }
        }
      }
    }
  });

  // Trigger update on the original selector to sync with theme.js
  const originalSelector = productArea.querySelector('.original-selector');
  if (originalSelector) {
    for (let i = 0; i < originalSelector.options.length; i++) {
      if (originalSelector.options[i].value == variant.id) {
        originalSelector.selectedIndex = i;
        const event = new Event('change', { bubbles: true });
        originalSelector.dispatchEvent(event);
        break;
      }
    }
  }

  // Update availability for all containers
  document.querySelectorAll('.variant-cards-container').forEach(function(container) {
    if (container.closest('.product-area') === productArea) {
      updateVariantCardAvailability(container);
    }
  });
}

function initVariantCards() {
  const variantCardContainers = document.querySelectorAll('.variant-cards-container');
  
  variantCardContainers.forEach(container => {
    const select = container.querySelector('.variant-cards-select');
    const cards = container.querySelectorAll('.variant-card');
    
    if (!select || cards.length === 0) return;
    
    // Add click event to each card
    cards.forEach(card => {
      card.addEventListener('click', function() {
        const value = this.getAttribute('data-variant-value');
        const isUnavailable = this.classList.contains('variant-card--unavailable');
        const productContainer = container.closest('.product-area');

        // Handle click on unavailable card
        if (isUnavailable && productContainer) {
          const productData = getProductDataForContainer(container);
          if (productData && productData.variants) {
            // Get current selections and option index
            const currentSelections = getCurrentSelections(productContainer);
            const selectorWrapper = container.closest('.selector-wrapper');
            const allWrappers = Array.from(productContainer.querySelectorAll('.selector-wrapper'));
            const clickedOptionIndex = allWrappers.indexOf(selectorWrapper);

            if (clickedOptionIndex !== -1) {
              const closestVariant = findClosestAvailableVariant(
                productData,
                clickedOptionIndex,
                value,
                currentSelections
              );

              if (closestVariant) {
                // Update all selections to the closest variant
                updateAllSelectionsToVariant(closestVariant, productContainer);
                return;
              }
            }
          }
          // If no closest variant found, continue with normal click handling
          // which will show "This Combination is Unavailable"
        }

        // Update the select element
        for (let i = 0; i < select.options.length; i++) {
          if (select.options[i].value === value) {
            select.selectedIndex = i;
            break;
          }
        }
        
        // Trigger change event on select to update the product
        const changeEvent = new Event('change', { bubbles: true });
        select.dispatchEvent(changeEvent);
        
        // Update card styling
        cards.forEach(c => c.classList.remove('variant-card--selected'));
        this.classList.add('variant-card--selected');
        
        // Find the option selector container
        const optionName = container.closest('.selector-wrapper').getAttribute('data-option-name');
        if (!optionName) return;
        
        if (!productContainer) return;
        
        // Update the main variant selector used by Shopify
        const originalSelector = productContainer.querySelector('.original-selector');
        if (originalSelector) {
          // Get current selections for all options
          const optionSelectors = productContainer.querySelectorAll('.selector-wrapper');
          const selectedOptions = {};
          
          optionSelectors.forEach(selector => {
            const name = selector.getAttribute('data-option-name');
            if (!name) return;
            
            // Get the selected value from either cards or regular select
            let selectedValue;
            const cardContainer = selector.querySelector('.variant-cards-container');
            if (cardContainer) {
              const cardSelect = cardContainer.querySelector('.variant-cards-select');
              selectedValue = cardSelect.value;
            } else {
              const regularSelect = selector.querySelector('select');
              selectedValue = regularSelect ? regularSelect.value : null;
            }
            
            if (selectedValue) {
              selectedOptions[name] = selectedValue;
            }
          });
          
          // Find the matching variant in the original selector
          for (let i = 0; i < originalSelector.options.length; i++) {
            const variantOption = originalSelector.options[i];
            const variantTitle = variantOption.text.trim();
            const variantParts = variantTitle.split(' / ');
            
            // Check if this variant matches all our selected options
            let isMatch = true;
            let optionIndex = 0;
            for (const optName in selectedOptions) {
              if (variantParts[optionIndex] !== selectedOptions[optName]) {
                isMatch = false;
                break;
              }
              optionIndex++;
            }
            
            if (isMatch && optionIndex === Object.keys(selectedOptions).length) {
              originalSelector.selectedIndex = i;
              const event = new Event('change', { bubbles: true });
              originalSelector.dispatchEvent(event);
              break;
            }
          }
        }
      });
    });
    
    // Sync select changes with card display
    select.addEventListener('change', function() {
      const selectedValue = this.value;
      
      cards.forEach(card => {
        const cardValue = card.getAttribute('data-variant-value');
        if (cardValue === selectedValue) {
          card.classList.add('variant-card--selected');
        } else {
          card.classList.remove('variant-card--selected');
        }
      });

      // Update availability for all containers in the product area
      const productArea = container.closest('.product-area');
      if (productArea) {
        productArea.querySelectorAll('.variant-cards-container').forEach(function(c) {
          updateVariantCardAvailability(c);
        });
      }
    });

    // Initialize availability on load
    updateVariantCardAvailability(container);
  });
}

function initAccordions() {
  // Only apply accordion on screens smaller than 1200px
  if (window.innerWidth >= 1200) {
    // Remove accordion functionality on larger screens
    removeAccordionFunctionality();
    return;
  }
  
  const variantInfos = document.querySelectorAll('.variant-card__info');
  
  variantInfos.forEach(info => {
    const metafieldContent = info.querySelector('.metafield-rich_text_field');
    if (!metafieldContent) return;
    
    // Check if accordion is already initialized
    if (info.classList.contains('has-accordion')) return;
    
    // Add accordion class
    info.classList.add('has-accordion', 'accordion-collapsed');
    
    // Create toggle button
    const toggleBtn = document.createElement('button');
    toggleBtn.className = 'accordion-toggle-btn';
    toggleBtn.setAttribute('aria-label', 'Expand details');
    toggleBtn.setAttribute('type', 'button');
    
    // Insert button at the beginning of the info container
    info.insertBefore(toggleBtn, info.firstChild);
    
    // Add click event
    toggleBtn.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      if (info.classList.contains('accordion-collapsed')) {
        info.classList.remove('accordion-collapsed');
        info.classList.add('accordion-expanded');
        toggleBtn.classList.add('hidden');
      }
    });
  });
}

function removeAccordionFunctionality() {
  const variantInfos = document.querySelectorAll('.variant-card__info.has-accordion');
  
  variantInfos.forEach(info => {
    // Remove accordion classes
    info.classList.remove('has-accordion', 'accordion-collapsed', 'accordion-expanded');
    
    // Remove toggle button
    const toggleBtn = info.querySelector('.accordion-toggle-btn');
    if (toggleBtn) {
      toggleBtn.remove();
    }
  });
} 